import React, { Component } from "react";
import { Routes, BrowserRouter, Route } from "react-router-dom";
import Home from './menus/Home';
import Delivery from './menus/Delivery';
import Careers from './menus/Careers';
import Press from './menus/Press';
import Customer from './menus/Customer';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Privacy from './read-only/Privacy';
import Terms from './read-only/Terms';
import Disclosure from './read-only/Disclosure';
import Company from './read-only/Company';
import './App.css';
class App extends Component {
  render() {
    return (
      <>
        <Navbar />
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/Delivery" element={<Delivery />} />
            <Route exact path="/Careers" element={<Careers />} />
            <Route exact path="/Press" element={<Press />} />
            <Route exact path="/Customer" element={<Customer />} />
            <Route exact path="/Privacy" element={<Privacy />} />
            <Route exact path="/Terms" element={<Terms />} />
            <Route exact path="/Disclosure" element={<Disclosure />} />
            <Route exact path="/Company" element={<Company />} />
          </Routes>
        </BrowserRouter>
        <Footer />
      </>
    );
  }
}
export default App;